import { AlertTriangle } from 'lucide-react';

function DeleteStudentConfirmModal({ isOpen, student, onClose, onConfirm }) {
  if (!isOpen) return null;
  const studentName = student?.student_name || student?.name || 'this student';

  return (
    <>
      <div className="fixed inset-0 bg-black/60 z-[110] backdrop-blur-sm" onClick={onClose} />
      <div className="fixed inset-0 z-[110] flex items-center justify-center p-4">
        <div className="bg-screen-bg rounded-lg p-6 max-w-md w-full border border-purple-glow-30 shadow-glow-lg" onClick={(e) => e.stopPropagation()}>
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 bg-red-500/15 rounded-full"><AlertTriangle size={24} className="text-red-500" /></div>
            <h3 className="text-lg font-semibold text-text-main">Confirm Delete</h3>
          </div>
          <p className="text-text-sub mb-6">
            Are you sure you want to delete <span className="font-semibold text-text-main">{studentName}</span>? This action cannot be undone.
          </p>
          <div className="flex gap-3 justify-end">
            <button onClick={onClose} className="px-4 py-2 rounded-lg border border-purple-glow-20 text-text-main hover:bg-purple-glow-5 transition-colors cursor-pointer">Cancel</button>
            <button onClick={onConfirm} className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition-colors cursor-pointer">Delete</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeleteStudentConfirmModal;